import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon/icon';
import SidebarItem from './sidebaritem';
import './style';
import { CaretDown, CaretUp } from '@phosphor-icons/react';

const CollapsibleItem = (props) => {
  const {
    label,
    icon,
    subItems, 
    colorMode, 
    onMenuClick, 
    selectedItem, 
  } = props;
  const [isOpen, setIsOpen ] = useState(false);
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className={`collapsible-item ${isOpen ? 'open': ''}  `}>
      <div className={`sidebar-item flex justify-between ${colorMode === 'black' ? 'color-black' : '' }`} 
        onClick={toggleOpen}>
        <div className='flex gap-3'>
          {icon && <Icon>{icon}</Icon>}
          {label}
        </div>
        {!isOpen ? (<CaretDown size={16}
          color='#101010'/> 
        ):(
          <CaretUp size={16}
            color='#101010'
          />)}
      </div>
      {isOpen && (
        <div className='sub-items ml-8'>
          {subItems.map((subItem, index) => (
            <SidebarItem
              key={index}
              label={subItem.label}
              icon={subItem.icon}
              onClick={() => onMenuClick(subItem)}
              isSelected={selectedItem === subItem}
              content={subItem.content}
            />
          ))}
        </div>
      )}

    </div>
  )
}
CollapsibleItem.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node,
  subItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
      onClick: PropTypes.func.isRequired,
      isSelected: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  colorMode: PropTypes.oneOf(['black', 'grey-to-black']),
};

CollapsibleItem.defaultProps = {
  icon: null,
  colorMode: 'black',
};

export default CollapsibleItem;